import type { FC } from "react";
import React from "react";

import type { InputProps } from "@busbud/horizon";
import { Input } from "@busbud/horizon";

export function normalizeString(value: string): string {
  return value.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
}

type ChangeEvent = React.ChangeEvent<HTMLInputElement>;

export interface NoDiacriticsInputProps extends InputProps {
  onChange: (event: ChangeEvent) => void | undefined;
  onBlur?: ((event: React.FocusEvent<HTMLInputElement>) => void) | undefined;
  tabIndex?: number;
  ref?: React.Ref<HTMLInputElement>;
}

export const NoDiacriticsInput: FC<NoDiacriticsInputProps> = ({
  onBlur: handleInputBlur,
  onChange,
  value,
  ref,
  ...props
}) => {
  function onBlur(e: React.FocusEvent<HTMLInputElement>) {
    const newValue = normalizeString(e.target.value || "");
    const event = { target: { value: newValue } };
    onChange(event as ChangeEvent);
    handleInputBlur?.(e);
  }
  return (
    <Input
      {...props}
      ref={ref}
      value={value}
      onBlur={onBlur}
      onChange={onChange}
    />
  );
};
